/**
 * @author Kelnik
 *
 * ParametricMap - Карта для параметрического
 */

import Sticky from 'sticky-js';
import Utils from 'common/scripts/utils';

// eslint-disable-next-line no-undef
const Mapboxgl = window.mapboxgl;

class ParametricMap {
    constructor(options) {
        this.options = options;
        this.containerSelector = '.j-parametric-map';
        this.container = options.wrapper ? options.wrapper.querySelector(this.containerSelector) : null;

        this.wrapMapSelector = '.j-parametric-map-wrap';
        this.zoomInSelector = '.j-parametric-zoom-in';
        this.zoomOutSelector = '.j-parametric-zoom-out';

        this.panelSelector = '.j-parametric-panel';

        this.map = null;
        this.markers = [];

        this.init();
    }

    init() {
        if (!this.container) {
            return;
        }

        this._initElements();
        this._createWrapperPanel();
        this._setHeightWrapperPanel();
        this._initSticky();
        this._bindEvents();
        this._setWidthContainer();
        this._initMap();
    }

    _initElements() {
        this.wrapMap = this.container.querySelector(this.wrapMapSelector);
        this.zoomIn = this.container.querySelector(this.zoomInSelector);
        this.zoomOut = this.container.querySelector(this.zoomOutSelector);
        this.panel = this.container.querySelector(this.panelSelector);
    }

    _initSticky() {
        this.sticky = new Sticky(this.containerSelector);
    }

    _initMap() {
        if (!Mapboxgl) {
            return;
        }

        Mapboxgl.accessToken = this.options.accessToken;

        this.map = new Mapboxgl.Map({
            container: 'map-box',
            style    : this.options.style || 'mapbox://styles/mapbox/streets-v11',
            center   : this.options.center || {
                lon: 0,
                lat: 0
            },
            zoom   : this.options.zoom || 3,
            minZoom: this.options.minZoom || 10,
            maxZoom: this.options.maxZoom || 16
        });

        this.map.scrollZoom.disable();
    }

    removeMarkers() {
        this.markers.forEach((marker) => {
            marker.remove();
        });
    }

    addMarkersInMap(markers) {
        if (!markers || !markers.length) {
            return;
        }

        this.markersObject = markers;

        markers.forEach((marker) => {
            const elem = document.createElement('div');

            elem.classList.add('parametric-map__marker', 'j-parametric-marker');
            elem.setAttribute('data-id', marker.id);
            elem.style.backgroundImage = `url(${marker.img})`;

            this.markers.push(new Mapboxgl.Marker(elem)
                .setLngLat(marker.coords)
                .addTo(this.map));
        });
    }

    activeOnlyMarker(id = -1) {
        this.markers.forEach((marker) => {
            const markerEl = marker.getElement();

            if (Number(markerEl.dataset.id) === Number(id)) {
                markerEl.classList.add('is-active');
            } else {
                markerEl.classList.remove('is-active');
            }
        });
    }

    centerMarker(id) {
        const currentMarker = this.markersObject.find((marker) => {
            return Number(marker.id) === Number(id);
        });

        this.setCenter(currentMarker.coords);
    }

    setCenter(coords) {
        this.map.flyTo({
            center: coords,
            speed : 0.4,
            curve : 1
        });
    }

    fitBounds() {
        const bounds = new Mapboxgl.LngLatBounds();

        this.markersObject.forEach((marker) => {
            bounds.extend(marker.coords);
        });

        this.map.fitBounds(bounds, {padding: 100});
    }

    _bindEvents() {
        window.addEventListener('resize', Utils.debounce(this._resizeWindow.bind(this), 50));

        this.zoomIn.addEventListener('click', () => {
            if (this.map) {
                this.map.zoomIn();
            }
        });

        this.zoomOut.addEventListener('click', () => {
            if (this.map) {
                this.map.zoomOut();
            }
        });
    }

    _resizeWindow() {
        this._setHeightWrapperPanel();
        this._setWidthContainer();

        if (this.map) {
            this.map.resize();
        }
    }

    _setWidthContainer() {
        const width = this._getWidthContainer();

        if (!width) {
            return;
        }

        this.wrapMap.style.width = `${width}px`;

        if (this.panel) {
            this.panel.style.width = `${width}px`;
        }
    }

    _getWidthContainer() {
        return (window.innerWidth - this.container.getBoundingClientRect().left).toFixed(2);
    }

    stickyUpdate() {
        this.sticky.update();
    }

    _createWrapperPanel() {
        if (!this.panel) {
            return;
        }

        this.wrapperPanel = document.createElement('div');
        this.wrapperPanel.classList.add('parametric-map__panel-wrapper');
        this.panel.classList.add('parametric-map__panel_is_fix');
        this.panel.after(this.wrapperPanel);
    }

    _setHeightWrapperPanel() {
        if (!this.wrapperPanel) {
            return;
        }

        this.wrapperPanel.style.height = `${this.panel.offsetHeight}px`;
    }
}

export default ParametricMap;
